import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { map } from 'rxjs/operators';

import { Observable } from 'rxjs';

import { BaseComponent } from '@rs-bank/rs-core';

import { StatementRouterParameters } from '../../statements-model';
import {
  Reference,
  ReferenceGroup,
  ReferenceGroupListResponse,
} from '../references.entities';
import { ReferencesFacadeService } from '../references.facade.service';

@Component({
	selector: 'app-references-block',
	templateUrl: './references-block.component.html',
	styleUrls: ['./references-block.component.less'],
	standalone: false,
})
export class ReferencesBlockComponent extends BaseComponent implements OnInit {

	@Input()
	public title: string;
	@Input()
	public dataSource$: Observable<ReferenceGroupListResponse>;


	public routerParameters: StatementRouterParameters = {productContractId: this.activatedRoute.snapshot.params.productContractId ? +this.activatedRoute.snapshot.params.productContractId : undefined}

	public referencesOrdered$ = this.referencesFacadeService.getgetReferencesOrdered();

	public references$: Observable<{
		references: Array<ReferenceGroup | Reference>;
		emptyListText: string | undefined;
	}> = this.referencesFacadeService.getReferencesGroupList(this.routerParameters.productContractId)
		.pipe(
			map((referenceGroupListResponse: ReferenceGroupListResponse) => {

				return {
					references: [
						...(referenceGroupListResponse.groups || []),
						...(referenceGroupListResponse.referencesWithoutGroup || []),
					],
					emptyListText: referenceGroupListResponse.emptyListText || undefined,
				};

			}),
		);

	constructor(
		public override changeDetectorRef: ChangeDetectorRef,
		private referencesFacadeService: ReferencesFacadeService,
		private activatedRoute: ActivatedRoute,
	) {
		super(changeDetectorRef);
	}


	public ngOnInit(): void {

	}
}
